/* Kindred Pleasure: free gift step on the cart shipping bar.
   Settings live in the "Free gift bar" custom liquid section (footer). */
(function () {
  var cfg = window.kpGiftBar || {};
  if (!cfg.threshold || !cfg.handle || !window.customElements) return;

  var giftAvailable = false;
  var giftVariantId = null;
  var busy = false;

  function rate() {
    return parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function refresh() {
    document.querySelectorAll('cart-free-shipping').forEach(function (el) {
      try { el.updateShippingIndicator(); } catch (e) {}
    });
  }

  function getCart() {
    return fetch(root() + 'cart.js').then(function (r) { return r.json(); });
  }

  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === giftVariantId) return cart.items[i];
    }
    return null;
  }

  function addGift(event) {
    if (event) event.preventDefault();
    if (busy || !giftVariantId) return;
    busy = true;
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1 }] })
    }).then(function () { window.location.href = root() + 'cart'; })
      .catch(function () { busy = false; });
  }

  // Keep the gift in step with the cart: show an add button when earned,
  // and take it back out if the order drops below the gift amount.
  function syncGift(el, qualifies) {
    getCart().then(function (cart) {
      var line = giftLine(cart);
      if (qualifies) {
        if (line) {
          el.messageElement.innerHTML = cfg.reached;
        } else {
          el.messageElement.innerHTML = cfg.reached +
            ' <a href="#" class="kp-gift-add" style="text-decoration: underline;">Add my free Whim</a>';
        }
      } else if (line && !busy) {
        busy = true;
        fetch(root() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function () { window.location.reload(); })
          .catch(function () { busy = false; });
      }
    }).catch(function () {});
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.kp-gift-add')) addGift(event);
  });

  customElements.whenDefined('cart-free-shipping').then(function () {
    var C = customElements.get('cart-free-shipping');
    var original = C.prototype.updateShippingIndicator;

    C.prototype.updateShippingIndicator = function () {
      var shipping = this.threshold;
      var gift = Math.round(cfg.threshold * rate());
      var total = this.totalPrice;

      if (giftAvailable && gift > shipping && total >= shipping) {
        this.progressBarElement.style.width = Math.min(100, Math.round(total * 100 / gift)) + '%';
        if (total >= gift) {
          this.messageElement.innerHTML = cfg.reached;
          syncGift(this, true);
        } else {
          var amount = '<span class="free-shipping__price">' +
            Shopify.formatMoney(gift - total, this.dataset.currencyFormat) + '</span>';
          this.messageElement.innerHTML = String(cfg.unreached).split('[amount]').join(amount);
          syncGift(this, false);
        }
        return;
      }
      var result = original.call(this);
      if (giftAvailable) syncGift(this, false);
      return result;
    };

    fetch(root() + 'products/' + cfg.handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        giftAvailable = !!(p && p.available);
        giftVariantId = p && p.variants && p.variants[0] ? p.variants[0].id : null;
        refresh();
      })
      .catch(function () {});
  });
})();
